
import create from '../utils/create';
import Field from '../field';
import { isAndroid } from '../utils';

export default create({
  render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', [_c('field', _vm._g({ ref: "field", attrs: { "rows": "1", "autosize": "", "type": "textarea", "maxlength": "200", "value": _vm.value, "error": _vm.error, "label": _vm.$t('label'), "placeholder": _vm.$t('placeholder') }, on: { "click-icon": _vm.onClickIcon } }, _vm.$listeners), [_c('div', { attrs: { "slot": "icon" }, slot: "icon" }, [_vm.showIcon && _vm.isAndroid ? _c('span', { class: _vm.b('finish') }, [_vm._v(_vm._s(_vm.$t('complete')))]) : _vm.showIcon ? _c('icon', { attrs: { "name": "clear" } }) : _vm._e()], 1)]), _vm._l(_vm.searchResult, function (express) {
      return _vm.showSearchList ? _c('cell', { key: express.name + express.address, attrs: { "title": express.name, "label": express.address, "icon": "location", "clickable": "" }, on: { "click": function click($event) {
            _vm.onSelect(express);
          } } }) : _vm._e();
    })], 2);
  },

  name: 'address-edit-detail',

  components: {
    Field: Field
  },

  props: {
    value: String,
    error: Boolean,
    focused: Boolean,
    searchResult: Array,
    showSearchResult: Boolean
  },

  created: function created() {
    this.isAndroid = isAndroid();
  },


  computed: {
    showSearchList: function showSearchList() {
      return this.showSearchResult && this.focused && this.searchResult.length;
    },
    showIcon: function showIcon() {
      return this.value && this.focused;
    }
  },

  methods: {
    onClickIcon: function onClickIcon() {
      if (this.isAndroid) {
        this.$refs.field.blur();
      } else {
        this.$emit('input', '');
      }
    },
    onSelect: function onSelect(express) {
      this.$emit('input', ((express.address || '') + ' ' + (express.name || '')).trim());
      this.$emit('select-search', express);
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/address-edit/Detail.js
// module id = 230
// module chunks = 39